import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { UsersService } from 'src/app/services/UsersService';
import { formatDate } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { UsersModel } from 'src/app/models/UsersModel';


@Component({
  selector: 'app-user-change-pop',
  templateUrl: './user-change-pop.component.html',
  styleUrls: ['./user-change-pop.component.css']
})
export class UserChangePopComponent implements OnInit {

  userid = '' ;
  username = '' ;
  isDisabled: boolean = true;
  Oldpassword = '' ;
  Newpassword = '' ;
  confirmpassword = '' ;
  password = '' ;
  menutype = '' ;
  itpicture = '' ;
  compcode = '1' ;
  userid1 = 'sa' ;

  acc_compcode = '';
  acc_Language ='E';
  acc_ErrorMessage = 'Error';
  grp_compCode = '';
  acc_password = '';
  Check_User = 'False';
  Check_Password = 'False';
  Check_Company = 'False';
  Check_message1 = '';
  Check_message2 = '';
  Check_message3 = '';

  Get_Login : boolean = false;
  myinput = document.getElementById('newpassword') as HTMLInputElement;
  newimput = document.getElementById('confirm') as HTMLInputElement;
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public usersService: UsersService,
    public users: UsersModel,
    public storage: LocalStorageService,
    public usersSelectedData: UsersModel,                ///----------- for searching pop up -----------
    public dialogRef: MatDialogRef<UserChangePopComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
      this.userid = data.userid;
    }

  ngOnInit(): void {
    this.myinput.disabled=false;
    this.newimput.disabled=false;
    this.checkpassword();
  }
  submitUsers() {
    this.users.userID1 = this.storage.retrieve('stguserId');
    this.users.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

    this.users.compCode = this.storage.retrieve('stgcompCode');
    this.users.userID = this.userid;
    this.users.password = this.confirmpassword;

     console.log("users : "+ this.users);

     if (this.confirmpassword != '')
{    this.usersService.Usercahngpassword(this.users).subscribe(data => {

     this.mesgSave();
    },
  
       error => { alert(error); }

    );
  } else{this.messageerrEnglish();}
  }
  retriveUsers() {
    this.usersService.getusers(this.userid, this.storage.retrieve('stgcompCode')).subscribe((data: UsersModel) => {
      this.username = data.userName;

      this.password = data.password;



       }

    );
  }
  retriveUserspasword() {
    this.usersService.CheckUser(this.userid, this.Oldpassword).subscribe((data: UsersModel) => {
      this.username = data.userName;

      this.password = data.password;



      if (data.password != null)
        {
          this.Check_Password = 'True';
          this.isDisabled = false;
          this.checkpassword();
        }
        else
        {
          this.Check_Password = 'False';
          this.isDisabled = true; //!this.isDisabled;
        }
        console.log(data.password + "/ "+ this.Check_Password + "/" +this.isDisabled);

       }

    );
  }

  Savenewpassword() {
    this.usersService.Changepass(this.userid, this.confirmpassword).subscribe((data: UsersModel) => {
      this.username = data.userName;

      this.password = data.password;


         console.log(data.password + "/ "+ this.Check_Password + "/" +this.isDisabled);

       }

    );
  }
  reload(){
    window.location.reload();
  }
  mesgSave() {
      Swal({
        title: 'Your work has been saved',

        type: 'success',
        showConfirmButton: false,

        timer: 1500
        });
  }


  LoginUser() {
    //// =========== Check User ========================
    this.Check_message1 = '';
    this.Check_User = 'False';
    if (this.username == null || this.username == "") {
      this.Check_User = 'False'
      if(this.acc_Language == 'E') {this.Check_message1 = 'Invalid User Code  .. Please try again'}
      if(this.acc_Language == 'A') {this.Check_message1 = 'تأكد من كود المستخدم  .. من فضلك حاول مرة أخرى'}

    } else {
      this.Check_User = 'true';
    }
    //// =========== Check PassWord ===================
    this.Check_Password = 'False';
    this.Check_message2 = '';
    if (this.Oldpassword != this.acc_password) {
      this.username = "Invalid User ID please try again",
        this.Check_Password = 'False'
        if(this.acc_Language == 'E') {this.Check_message2 = 'Invalid Password  .. '}
        if(this.acc_Language == 'A') {this.Check_message2 = 'تأكد من كلمة السر .. '};
    }
    else
    {
      this.Check_Password = 'true';
    }
    //// =========== Check Company ===================

    if(this.Check_User == 'true' && this.Check_Password == 'true' )
    {
      this.Get_Login = true;
    }
    else
    {
      this.Get_Login = false;
      this.messageEnglish();
    }

  }
  messageEnglish(){

    Swal({
      title: 'Your work has been saved',
      text: this.Check_Password ,
      type: 'warning',
      showConfirmButton: false,

      timer: 3000
      });

  }
  messageerrEnglish(){

    Swal({
      title: 'Cannot save empty password',
      text: this.Check_Password ,
      type: 'warning',
      showConfirmButton: false,

      timer: 3000
      });

  }
  checkpassword(){

        //// =========== Check PassWord ===================
        const password = '';

        this.Check_message2 = '';
        if (this.Check_Password == 'true' || this.confirmpassword == '' ) {
          this.myinput.disabled=true;
          this.newimput.disabled=true;

        }
        else
        {
          this.myinput.disabled=false;
          this.newimput.disabled=false;
        }

  }
  checknewpassword() {

    //// =========== Check PassWord ===================
    this.Check_Password = 'False';
    this.Check_message2 = '';
    if (this.Newpassword != this.confirmpassword || this.confirmpassword == '') {
      //this.username = "The password not matched"
      this.Check_Password = 'The password not matched';
         this.messageEnglish();
    }
    else
    {

      console.log('john' + this.confirmpassword );
      this.Savenewpassword();
    }

  }

}
